import {runtimeTr} from "@/utils/Tr";

const StaticPerms = {
/*
*  !!!!!!!!!!!!!!!!!!!!!! Autogenerated file, source: Perms.js.vm
*/

    ALL_BUSINESS_ENTITIES_AUDIT : {name:'ALL_BUSINESS_ENTITIES_AUDIT', code: 153, label: "All Business Objects - audit/history", type:'static' },
    ALL_BUSINESS_ENTITIES_READ : {name:'ALL_BUSINESS_ENTITIES_READ', code: 151, label: "All Business Objects - read/list", type:'static' },
    ALL_BUSINESS_ENTITIES_WRITE : {name:'ALL_BUSINESS_ENTITIES_WRITE', code: 152, label: "All Business Objects - add/edit/delete", type:'static' },
    ALL_DASHLETS : {name:'ALL_DASHLETS', code: 166, label: "Access To All Dashlets", type:'static' },
    ALL_REPORT : {name:'ALL_REPORT', code: 165, label: "Access To All Reports", type:'static' },
    APPLICATION_ARCHITECT : {name:'APPLICATION_ARCHITECT', code: 154, label: "Application architect", type:'static' },
    ASSIGN_PRODUCTS_TO_SEASON : {name:'ASSIGN_PRODUCTS_TO_SEASON', code: 160, label: "Assign Products to Season", type:'static' },
    BOOKING_NOTIFICATION : {name:'BOOKING_NOTIFICATION', code: 163, label: "Booking Notification", type:'static' },
    BRANDING_PARAMETERS : {name:'BRANDING_PARAMETERS', code: 161, label: "Branding Parameters", type:'static' },
    BROADCAST_NOTIFICATIONS : {name:'BROADCAST_NOTIFICATIONS', code: 2, label: "Broadcast notifications to all users", type:'static' },
    DATA_IMPORT : {name:'DATA_IMPORT', code: 158, label: "Data import", type:'static' },
    EXTRA_LOGISTIC_BOOKING : {name:'EXTRA_LOGISTIC_BOOKING', code: 162, label: "Logistic Booking Extra All Edit", type:'static' },
    IHUB_TRIGGER : {name:'IHUB_TRIGGER', code: 157, label: "Integration Hub Trigger", type:'static' },
    IHUB_USER : {name:'IHUB_USER', code: 156, label: "Integration Hub User", type:'static' },
    ORGANIZATION_SETTINGS : {name:'ORGANIZATION_SETTINGS', code: 1, label: "Edit/View Organization's configuration", type:'static' },
    PP_SAMPLE_DELETE : {name:'PP_SAMPLE_DELETE', code: 164, label: "PP Sample Delete", type:'static' },
    PRODUCT_ADMIN : {name:'PRODUCT_ADMIN', code: 159, label: "All Product admin", type:'static' },
    SUPERUSER : {name:'SUPERUSER', code: 150, label: "Superuser", type:'static' },
    WRITE_ACCESS_TO_FIELD_UNIT : {name:'WRITE_ACCESS_TO_FIELD_UNIT', code: 167, label: "Write access to change field Unit -> Product", type:'static' },
}

const Perms = {};

export const FORMS_READ_SUB_CODE = 0;
export const FORMS_WRITE_SUB_CODE = 1;
export const FORMS_LIST_SUB_CODE = 2;

export const FIELD_READ_SUB_CODE = 0;
export const FIELD_WRITE_SUB_CODE = 1;
export const FIELD_WORKFLOW_SUB_CODE = 2;


export const FORMS_OFFSET = 500;
export const BUSINESS_OBJECTS_OFFSET = 200;
export const FORMS_SUB_CODE_MAX_VALUE = 4;

function readCodeForForm(formId){
    return formId * (FORMS_SUB_CODE_MAX_VALUE + 1) + FORMS_OFFSET + FORMS_READ_SUB_CODE;
}
function writeCodeForForm(formId){
    return formId * (FORMS_SUB_CODE_MAX_VALUE + 1) + FORMS_OFFSET + FORMS_WRITE_SUB_CODE;
}
function listCodeForForm(formId){
    return formId * (FORMS_SUB_CODE_MAX_VALUE + 1) + FORMS_OFFSET + FORMS_LIST_SUB_CODE;
}

function readCodeForField(fieldId){
    return fieldId * (FORMS_SUB_CODE_MAX_VALUE + 1) + FORMS_OFFSET + FIELD_READ_SUB_CODE;
}
function writeCodeForField(fieldId){
    return fieldId * (FORMS_SUB_CODE_MAX_VALUE + 1) + FORMS_OFFSET + FIELD_WRITE_SUB_CODE;
}
function workflowCodeForField(fieldId){
    return fieldId * (FORMS_SUB_CODE_MAX_VALUE + 1) + FORMS_OFFSET + FIELD_WORKFLOW_SUB_CODE;
}

for(const name in StaticPerms){
    Perms[name] = StaticPerms[name];
}

export function setDynamicPermissions(/** FormConfig[] */ forms){
    for(const name in Perms){
        delete Perms[name];
    }
    for(const name in StaticPerms){
        Perms[name] = {...StaticPerms[name],label:runtimeTr("api.permissions."+name,StaticPerms[name].label)};
    }
    const names = new Set();
    for(const form of forms){
        for(const fieldPerm of form.securedFields){
            if(fieldPerm.restrictedRead){
                const name = "FIELD_READ_" + fieldPerm.securityId;
                Perms[name]={
                    label:fieldPerm.readPermissionLabel,
                    code: readCodeForField(fieldPerm.securityId),
                    name,
                    type:'dynamic',
                    subtype:'field_read' };
                names.add(name);
            }

            if(fieldPerm.restrictedWrite){
                const name = "FIELD_WRITE_" + fieldPerm.securityId;
                Perms[name]={
                    label:fieldPerm.writePermissionLabel,
                    code: writeCodeForField(fieldPerm.securityId),
                    name,
                    type:'dynamic',
                    subtype:'field_write' };
                names.add(name);
            }

            if(fieldPerm.hasWorkflow){
                const name = "FIELD_WORKFLOW_" + fieldPerm.securityId;
                Perms[name]={
                    label:fieldPerm.workflowPermissionLabel,
                    code: workflowCodeForField(fieldPerm.securityId),
                    name,
                    type:'dynamic',
                    subtype:'field_workflow' };
                names.add(name);
            }
        }

        if (form.restrictedRead && !names.has("FORM_READ_" + form.formId )) {
            Perms["FORM_READ_" + form.formId]={
                label:form.readPermissionLabel,
                code: readCodeForForm(form.formId),
                name: "FORM_READ_" + form.formId,
                type:'dynamic',
                subtype:'read' };
            names.add("FORM_READ_" + form.formId );
        }
        if (form.restrictedWrite && !names.has("FORM_WRITE_" + form.formId )) {
            Perms["FORM_WRITE_" + form.formId]={
                label:form.writePermissionLabel,
                code: writeCodeForForm(form.formId),
                name: "FORM_WRITE_" + form.formId,
                type:'dynamic',
                subtype:'write' };
            names.add("FORM_WRITE_" + form.formId );
        }
        if (form.restrictedList && !names.has("FORM_LIST_" + form.formId )) {
            Perms["FORM_LIST_" + form.formId]={
                label:form.listPermissionLabel,
                code: listCodeForForm(form.formId),
                name: "FORM_LIST_" + form.formId,
                type:'dynamic',
                subtype:'list' };
            names.add("FORM_LIST_" + form.formId );
        }
    }
}

export function setDynamicPermissionsForReports(/** XlsReportConfig[] */ reports){
    const names = new Set();
    for(const form of reports){
        if (!names.has(form.securityCode)) {
            Perms[form.securityCode]={
                label:form.name,
                code: form.securityId,
                name: form.securityCode,
                type:'dynamic',
                subtype:'read' };
            names.add(form.securityCode);
        }
    }
}

export function setDynamicPermissionsForDashlets(/** DashletConfig[] */ dashletConfigs){
    const names = new Set();
    for(const form of dashletConfigs){
        if (!names.has(form.securityCode)) {
            Perms[form.securityCode]={
                label: form.title,
                code: form.securityId,
                name: form.securityCode,
                type:'dynamic',
                subtype:'read' };
            names.add(form.securityCode);
        }
    }
}

export default Perms;
